import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "./InterestModal.css";
import okIcon from "../../../../assets/icons/new-icons/ok.svg";
import exitIcon from "../../../../assets/icons/new-icons/exit.svg";
import { Timestamp } from "firebase/firestore";
import getJsUTC from "../../../../helpers/getJsUTC";

const style = {
  minHeight: "60vh",
};

const InterestModal = (props) => {
  const {
    interest,
    setInterest,
    comments,
    setComments,
    modalStatus,
    setModalStatus,
  } = props;

  const handleClose = () => {
    setModalStatus(false);
  };
  const [TextAreaMessage, setTextAreaMessage] = useState("");
  return (
    <Modal
      open={modalStatus}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="Custom-Modal-Box" sx={style}>
        <div className="interest-model">
          <div className="interest-model-header">
            <p className="modal-heading">Interest</p>
            <div
              className="modal-close-icon"
              onClick={() => {
                setModalStatus(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="currentColor"
                class="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          </div>
          <hr className="mb-4" />

          <div className="custom-check-box">
            <label className="check-box">
              &nbsp; Buy
              <input
                type="radio"
                name="interest"
                value="buy"
                onChange={(e) => {
                  setInterest(e.target.value);
                }}
                defaultChecked
                checked={interest === "buy"}
              />
              <span className="checkmark"></span>
            </label>

            <label className="check-box">
              &nbsp; Sell
              <input
                type="radio"
                name="interest"
                value="sale"
                onChange={(e) => {
                  setInterest(e.target.value);
                }}
                checked={interest === "sale"}
              />
              <span className="checkmark"></span>
            </label>

            <label className="check-box">
              &nbsp; Rent
              <input
                type="radio"
                name="interest"
                value="rent"
                onChange={(e) => {
                  setInterest(e.target.value);
                }}
                checked={interest === "rent"}
              />
              <span className="checkmark"></span>
            </label>
          </div>

          <div className="interest-comments">
            <label className="form-field-label" htmlFor="comments">
              Comments
            </label>
            <textarea
              name="comments"
              className="form-input-field"
              rows="5"
              cols="39"
              onChange={(e) => {
                setTextAreaMessage(e.target.value);
              }}
            />
          </div>

          <div className="recent-comments">
            {comments &&
              comments.map((comment, index) => {
                return (
                  <div className="calender-with-paragraph">
                    <div className="calender">
                      <p className="cal-dd dd-mm-yy">
                        {comment?.date?.toDate()?.toLocaleString("en-GB", {
                          day: "numeric",
                        })}
                      </p>
                      <p className="cal-mm dd-mm-yy">
                        {comment?.date?.toDate()?.toLocaleString("en-GB", {
                          month: "short",
                        })}
                      </p>
                      <p className="cal-yy dd-mm-yy">
                        {comment?.date?.toDate()?.toLocaleString("en-GB", {
                          year: "numeric",
                        })}
                      </p>
                    </div>
                    <p className="calender-paragraph">{comment?.message}</p>
                  </div>
                );
              })}
          </div>
        </div>
        <Box className="add-deal-btn-container">
          <button
            className="close-modal-btn"
            onClick={() => {
              setModalStatus(false);
            }}
          >
            Cancel
          </button>
          <button
            className="form-submit-button"
            onClick={(e) => {
              setModalStatus(false);
              if (TextAreaMessage === "") {
                return;
              }

              // handleSubmitInterestForm();
              setComments([
                ...comments,
                {
                  message: TextAreaMessage,
                  date: Timestamp.fromDate(new Date(getJsUTC())),
                },
              ]);
              setTextAreaMessage("");
            }}
          >
            Save
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default InterestModal;
